// @ts-nocheck
// https://github.com/JedWatson/react-select/tree/master/docs/examples
// https://codesandbox.io/s/checkedmultiselect-reactselect-3pjo7p
import './CheckedMultiSelect.css'
import ReactSelect, { components } from 'react-select'

/* interface CheckedMultiSelectProps {
    isOpen: boolean
    toggleOpen(): void
    options: Array<any>
    value
    onChange(selected): void
    hideSearch?: boolean | undefined
    children: React.ReactNode
    [x: string]
} */

const selectStyles = {
    control: provided => ({
        ...provided,
        minWidth: 240,
        margin: 8,
    }),
    menu: () => ({ boxShadow: 'inset 0 1px 0 rgba(0, 0, 0, 0.1)' }),
}

const Menu = props => <div className="CheckedMultiSelect-menu" {...props} />

const Blanket = props => <div className="CheckedMultiSelect-blanket" {...props} />

const Dropdown = ({ children, isOpen, target, onClose }) => (
    <div className="CheckedMultiSelect-dropdown">
        {target}
        {isOpen ? <Menu>{children}</Menu> : null}
        {isOpen ? <Blanket onClick={onClose} /> : null}
    </div>
)

export const Option = props => (
    <components.Option {...props}>
        <input type="checkbox" checked={props.isSelected} onChange={() => {}} />
        <span className="ml-2">{props.label}</span>
    </components.Option>
)

export const CheckedMultiSelect = ({
    isOpen,
    toggleOpen,
    options,
    value,
    onChange,
    hideSearch,
    children,
    ...props
}) => {
    const hideSearchOptions = hideSearch
        ? {
            Input: () => null,
            Placeholder: () => null,
            IndicatorsContainer: () => null,
            Control: () => null,
        }
        : {}
    
    return (
        <Dropdown isOpen={isOpen} onClose={toggleOpen} target={children}>
            <ReactSelect
                className="CheckedMultiSelect"
                classNamePrefix="CheckedMultiSelect"
                isMulti
                backspaceRemovesValue={false}
                components={{
                    DropdownIndicator: null,
                    IndicatorSeparator: null,
                    Option,
                    ...hideSearchOptions,
                }}
                controlShouldRenderValue={false}
                closeMenuOnSelect={false}
                hideSelectedOptions={false}
                isClearable={false}
                menuIsOpen
                onChange={onChange}
                options={options}
                styles={selectStyles}
                tabSelectsValue={false}
                value={value}
                {...props} />
        </Dropdown>
    )
}
